import { INCH } from './rules';

export const TRACK_PITCH = .075;
export const SASH_DEPTH = .055;

export const customTracks = (panelCount, baseTracks) => Math.max(Number(panelCount), baseTracks);

// One lane per sash is essential: reusing a lane prevents a full-width stack.
// At a corner, extra lanes extend OUTSIDE the two meeting glass planes.
export function stackLayout(run, product, corner = false, side = 'a') {
  const width = run.width_in * INCH, count = run.panels;
  const tracks = customTracks(count, product.track_count), depth = tracks * TRACK_PITCH;
  const left = -width / 2 + .04;
  // Butt-jointed moving stiles touch, rather than intersect, at the corner.
  const right = width / 2 + (corner ? (side === 'a' ? -SASH_DEPTH / 2 : SASH_DEPTH / 2) : -.04);
  const panelWidth = (right - left) / count;
  const pocket = product.pocket ? panelWidth + .065 : 0;
  const direction = side === 'a' ? -1 : 1;
  const trackCenter = corner ? direction * (tracks - 1) * TRACK_PITCH / 2 : 0;
  const stackX = product.pocket ? -width / 2 - pocket + .04 + panelWidth / 2 : left + panelWidth / 2;
  const panels = Array.from({ length: count }, (_, i) => ({
    start: left + panelWidth * (i + .5), target: stackX,
    z: corner ? direction * (count - 1 - i) * TRACK_PITCH : (i - (tracks - 1) / 2) * TRACK_PITCH,
  }));
  return { width, count, tracks, depth, trackCenter, panelWidth, pocket, stackX, panels };
}

export const panelPositionsAt = (layout, fraction) => layout.panels.map(panel => ({
  x: panel.start + (panel.target - panel.start) * fraction, z: panel.z,
}));